var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCloudFog = function SvgIconCloudFog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.568 3.66A5.375 5.375 0 1 1 14.625 14h-7.5a3.125 3.125 0 1 1 0-6.25h.005q.086 0 .172.004a7 7 0 0 0-.052.871 1 1 0 1 0 2 0 5.375 5.375 0 0 1 3.318-4.966m-4.075.868a7.4 7.4 0 0 0-.678 1.267l-.693-.045A5.125 5.125 0 0 0 7.125 16h7.5A7.375 7.375 0 1 0 8.493 4.528M6.75 17.75a1 1 0 1 0 0 2h4.5a1 1 0 1 0 0-2zm8.25 0a1 1 0 1 0 0 2h2.25a1 1 0 1 0 0-2zM8.75 22.5a1 1 0 0 1 1-1H15a1 1 0 1 1 0 2H9.75a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
export default SvgIconCloudFog;